import Beacon from "./beacon";

export default {
    components: {
        beacon: Beacon,
    }
}
